import { render } from "./PerfectPassCampaignPage.vue?vue&type=template&id=47bd0a90"
import script from "./PerfectPassCampaignPage.vue?vue&type=script&lang=js"
export * from "./PerfectPassCampaignPage.vue?vue&type=script&lang=js"

import "./PerfectPassCampaignPage.vue?vue&type=style&index=0&id=47bd0a90&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__